<template>
    <span>{{formattedValue}}</span>
</template>

<script>

    export default {
        name: "BooleanValue",
        props: {
            value: [Boolean],
            trueLabel: {
                type: String,
                default: '是'
            },
            falseLabel: {
                type: String,
                default: '否'
            },
        },
        computed: {
            formattedValue() {
                return this.value === null || this.value === undefined ? '' : (this.value ? this.trueLabel : this.falseLabel)
            }
        }
    }
</script>

